import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import Button from '../components/Button';
import CheckoutPageHeader from '../components/checkout/CheckoutPageHeader';
import PageContainer from '../layouts/PageContainer';
import { v2Colors } from '../design/theme';

const DISPLAY_FONT = '"Foregen", "Roboto Slab", Georgia, serif';

const STORES = [
  {
    id: 'banjara-hills',
    name: 'Banjara Hills',
    address:
      'No 11, Ground floor, Delta Seacon building, Block A, Banjara Hills Main Rd, Hyderabad, Telangana 500034',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/countrychickenco.appspot.com/o/store_images%2FBanjara.png?alt=media&token=4be97e17-5e7e-4d38-bf5a-fdf0e75a6d6e',
    mapsUrl: 'https://maps.app.goo.gl/rE5PKgpr9CEowNCo6',
  },
  {
    id: 'manikonda',
    name: 'Manikonda',
    address:
      'H.No :2-3-1, Shivapuri Colony, Muppas Panchavati Colony, Manikonda Jagir, Hyderabad, Telangana 500089',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/countrychickenco.appspot.com/o/store_images%2Fmanikonda.png?alt=media&token=19c8dbe5-3e20-48db-9de1-2142ba8f337d',
    mapsUrl: 'https://maps.app.goo.gl/jPd7QJC5tAAdnRnm7',
  },
  {
    id: 'pragati-nagar',
    name: 'Pragati Nagar',
    address:
      'Shop No - G2, Plot No: 1361, Lakshmi Nilayam, Pragathi Nagar Rd, beside Bhasyam School, Kukatpally, Hyderabad, Telangana 500090',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/countrychickenco.appspot.com/o/store_images%2Fpragatinagar.png?alt=media&token=adf6e262-c4c4-496a-acb0-45f213479f73',
    mapsUrl: 'https://maps.app.goo.gl/2MmaF9HL9UeFiJ599',
  },
  {
    id: 'kphb',
    name: 'KPHB',
    address:
      'plot no : 324,vijayan residency,venkatramana colony,Gokul Plot, Kukatpally Housing Board Colony, Hyderabad, Telangana 500072',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/countrychickenco.appspot.com/o/store_images%2Fkphb.png?alt=media&token=20cda75b-ca23-4678-9149-35743176acb2',
    mapsUrl: 'https://maps.app.goo.gl/MBF7iwkk2v2uKviC7',
  },
  {
    id: 'sainikpuri',
    name: 'Sainikpuri',
    address:
      'Plot No : 46, Survey NO:218/1, Country chicken Co, House number 37-10/6/1, Defence Colony, Sainikpuri, Telangana 500094',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/countrychickenco.appspot.com/o/store_images%2Fsainikpuri.png?alt=media&token=2c6442ab-b42b-4ac0-bc7f-640b50d6dbd3',
    mapsUrl: 'https://maps.app.goo.gl/MvHGzau6FYYtoLwL8',
  },
  {
    id: 'chandanagar',
    name: 'Chandanagar',
    address:
      'Plot No 2, Country Chicken Co, 111/22 & 23, Manjeera Pipeline Rd, Engineers Enclave, Chanda Nagar, Hyderabad, Telangana 500050',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/countrychickenco.appspot.com/o/store_images%2Fchandanagar.png?alt=media&token=19ec1a30-782a-4729-92d6-158e6a899339',
    mapsUrl: 'https://maps.app.goo.gl/TjkqL8hUNwb43ufG9',
  },
];

export default function Stores() {
  const openMaps = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <PageContainer sx={{ px: { xs: 1.5, sm: 2 }, pb: 4, maxWidth: { xs: 720, lg: 1200 } }}>
      <CheckoutPageHeader backTo="/v2" title="Our Stores" />

      <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
        {STORES.map((store) => (
          <Grid key={store.id} xs={12} sm={6} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Card
              elevation={0}
              sx={{
                width: '100%',
                maxWidth: 360,
                mx: 'auto',
                borderRadius: 1.5,
                overflow: 'hidden',
                border: '1px solid',
                borderColor: 'divider',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              }}
            >
              <Box
                component="img"
                src={store.imageUrl}
                alt={store.name}
                sx={{
                  display: 'block',
                  width: '100%',
                  height: { xs: 220, sm: 260, md: 300 },
                  objectFit: 'cover',
                }}
              />
              <Box
                sx={{
                  bgcolor: v2Colors.primary,
                  color: v2Colors.white,
                  px: 2,
                  py: 2,
                  textAlign: 'center',
                }}
              >
                <Typography
                  component="h2"
                  sx={{
                    fontFamily: DISPLAY_FONT,
                    fontSize: { xs: '1.5rem', sm: '1.75rem' },
                    fontWeight: 400,
                    mb: 1,
                  }}
                >
                  {store.name}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '0.9375rem',
                    fontWeight: 450,
                    lineHeight: 1.45,
                    mb: 1.5,
                    opacity: 0.95,
                  }}
                >
                  {store.address}
                </Typography>
                <Button
                  variant="contained"
                  onClick={() => openMaps(store.mapsUrl)}
                  sx={{
                    mt: 0.5,
                    bgcolor: v2Colors.white,
                    color: v2Colors.primary,
                    borderRadius: '999px',
                    px: 3,
                    textTransform: 'none',
                    fontWeight: 600,
                    '&:hover': {
                      bgcolor: v2Colors.selectedFill,
                    },
                  }}
                >
                  Find Store
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </PageContainer>
  );
}
